<template>
    <div style="height: 900px">
        <el-form :inline="true">
            <el-form-item>
                <el-button type="primary" @click="addUpdateInformationButton(null)">添加角色物品</el-button>
            </el-form-item>
        </el-form>

        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border stripe>
            <el-table-column prop="goodsCover" width="150" align="center" label="物品封面">
                <template slot-scope="scope">
                    <el-image style="width: 100px; height: 50px" :src="scope.row.goodsCover"
                        fit="scale-down"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="物品名称" align="center" prop="goodsName" width="300"></el-table-column>
            <!-- <el-table-column
                    align="center"
                    label="	商品原价"
                    prop="cartonsGoodsOriginalPrice"
                    width="150"
            ></el-table-column> -->
            <el-table-column align="center" label="	商品价格" prop="cartonsGoodsPrice" width="150"></el-table-column>
            <!-- <el-table-column
                    align="center"
                    label="	商品定金"
                    prop="storeGoodsPresellPrice"
                    width="150"
            ></el-table-column> -->
            <!-- <el-table-column
                    align="center"
                    label="	预售开始时间"
                    prop="preSaleStartTime"
                    width="150"
            ></el-table-column>
            <el-table-column
                    align="center"
                    label="	预售截止时间"
                    prop="preSaleEndTime"
                    width="150"
            ></el-table-column> -->
            <!-- <el-table-column
                    align="center"
                    label="	商品完成时间"
                    prop="productCompletionTime"
                    width="150"
            ></el-table-column>
            <el-table-column
                    align="center"
                    label="	到货时间"
                    prop="arrivalTime"
                    width="150"
            ></el-table-column>
            <el-table-column
                    align="center"
                    label="	补款发货时间"
                    prop="replenishmentDeliveryTime"
                    width="150"
            ></el-table-column> -->
            <el-table-column align="center" label="	总数" prop="totalCount" width="150"></el-table-column>
            <!-- <el-table-column
                    align="center"
                    label="	69码"
                    prop="sixtyNineCode"
                    width="150"
            ></el-table-column> -->
            <el-table-column prop="icon" align="center" width="400" fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" plain
                        @click="addUpdateInformationButton(scope.row.cartonsGoodsId)">编辑</el-button>
                    <el-button type="primary" plain
                        @click="addUpdateParameterButton(scope.row.cartonsGoodsId)">添加单品参数</el-button>
                    <template>
                        <el-popconfirm title="确定删除该物品吗？" @confirm="delHandle(scope.row.cartonsGoodsId)">
                            <el-button type="danger" plain slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>

                </template>
            </el-table-column>
        </el-table>
        <div style="text-align:center;padding-top: 20px">
            <el-button type="primary" @click="prev()">上一步</el-button>
            <el-button type="primary" @click="updStoreGoodsIsOnframe()" :disabled="saveBtnDisabled">上架</el-button>
        </div>
        <case-from ref="addCaseFrom" :store-goods-id="storeGoodsId" v-show="addCaseFromvisible"
            @refreshDataList="getCartonsGoods"></case-from>
        <!-- <AddParameter ref="getParameter" v-if="getParametervisible" @refreshDataList="getCartonsGoods"></AddParameter> -->
    </div>
</template>

<script>
import CaseFrom from "./CaseFrom";
// import AddParameter from "./AddParameter";
export default {
    name: "CaseList",
    components: {
        CaseFrom
    },
    props: {
        storeGoodsId: {
            type: Number,
        },
        storeGoodsStatus: {
            type: Number
        }
    },
    watch: {
        storeGoodsId(n, o) { //n为新值,o为旧值;
            this.storeGoodsId = n
        },
        storeGoodsStatus(n, o) {
            this.storeGoodsStatus = n
        }
    },
    data() {
        return {
            tableData: [],
            addCaseFromvisible: false,
            getParametervisible: false,
            saveBtnDisabled: true
        }
    },

    created() {
        console.log("预售", this.storeGoodsStatus)
        this.getCartonsGoods()
    },
    methods: {
        handleClose() {
            this.tableData = []
            this.addCaseFromvisible = false;
            this.saveBtnDisabled = true
        },
        addUpdateInformationButton(cartonsGoodsId) {
            this.addCaseFromvisible = true;
            this.$refs.addCaseFrom.init(this.storeGoodsId, this.storeGoodsStatus, cartonsGoodsId);
        },
        addUpdateParameterButton(id) {
            this.getParametervisible = true;
            this.$nextTick(() => {
                this.$refs.getParameter.init(id, this.storeGoodsId);
            })
        },
        getCartonsGoods() {
            if (this.storeGoodsId) {
                this.$axios.post("/admin/cartonsGoods/getSingerCartonsGoods", { storeGoodsId: this.storeGoodsId }).then(res => {
                    this.tableData = res.data
                    if (res.data && res.data.length > 0) {
                        this.saveBtnDisabled = false;
                    } else {
                        this.saveBtnDisabled = true
                    }
                })
            }

        },
        // 上一步
        prev() {
            console.log(22222)
            this.$emit("changeComponent1Data", -1)
        },

        //下架、上架商城商品
        updStoreGoodsIsOnframe() {
            var storeGoodsId = this.$parent.$parent.storeGoodsId
            this.$axios.post("/admin/singleStoreGoods/singleStoreGoods", { storeGoodsId: storeGoodsId }).then(res => {
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {
                        this.$parent.$parent.handleClose()
                        this.$parent.$parent.$parent.getStoreGoods()
                    }
                });
            });
        },
        delHandle(id) {
            this.$axios.post("/admin/singleStoreGoods/delSingleStoreGoodsRole", { id: id }).then(res => {
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'success',
                    onClose: () => {
                        this.getCartonsGoods()
                    }
                });
            })
        }

    }
}
</script>

<style scoped></style>
